import axios from '@/axios';

const RESOURCE_NAME = '/ecosystem/ecosystem-needs';

export default {
    getInfo(id) {
        return axios.get(`${RESOURCE_NAME}/get-info?id=${id}`);
    },

    getStartups(id, filters) {
        return axios.post(`${RESOURCE_NAME}/get-startups?id=${id}`, filters);
    },

    getStartupsListToAdd(id, search) {
        return axios.get(`${RESOURCE_NAME}/get-startups-list-to-add`, {
            params: {id, search}
        });
    },

    addStartup(id, startupId) {
        return axios.post(`${RESOURCE_NAME}/add-startup?id=${id}&startup_id=${startupId}`);
    },
}
